<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="發佈時間">
            <el-date-picker
              v-model="listMenuForm.startTime"
              type="date"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="MenuBtnWrap">
          <div class="btn" @click="$router.push('/addPhoto')">新增相簿</div>
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table :data="photoList" stripe style="width:100%;" height="660px">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column prop="id" width="180" label="ID"> </el-table-column>
          <el-table-column
            prop="prviateAlbumName"
            style="min-width:180px"
            :show-overflow-tooltip="true"
            label="相簿標題"
          >
          </el-table-column>
          <el-table-column width="180" label="主圖">
            <template slot-scope="scope">
              <div class="mainImgWrap normal_font">
                <img class="mainImg" :src="scope.row.imageMain" alt="" />
                <p
                  v-show="
                    scope.row.imageMain !== '' && scope.row.imageMain !== null
                  "
                  @click="previewImg(scope.row.imageMain)"
                >
                  查看
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="block" width="180" label="板塊">
            <template>
              <span>私密相簿</span>
            </template>
          </el-table-column>
          <el-table-column prop="pushTime" width="180" label="發佈時間">
          </el-table-column>
          <el-table-column prop="status" width="180" label="發佈狀態">
          </el-table-column>
          <el-table-column prop="limits" width="180" label="權限">
            <template>
              <span>會員</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="250">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.roofPlacement == 0"
                @click="toTop(scope.row.id, 1)"
                type="text"
                >置頂</el-button
              >
              <el-button
                v-else
                class="topBtn"
                type="text"
                @click="toTop(scope.row.id, 0)"
                >取消置頂</el-button
              >
              <el-button
                class="topBtn"
                type="text"
                :disabled="scope.row.status === '已隐藏'"
                @click="$router.push('/editPhoto?id=' + scope.row.id)"
                >編輯
              </el-button>
              <el-dropdown style="margin-left: 5px;cursor:pointer">
                <span style="color:#6c3dea">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button @click="delPhoto(scope.row.id)" type="text"
                      >刪除</el-button
                    ></el-dropdown-item
                  >
                  <el-dropdown-item>
                    <el-button
                      @click="getHide(scope.row.id, scope.row.status)"
                      type="text"
                      >{{
                        scope.row.status != "已隐藏" ? "隐藏" : "已隐藏"
                      }}</el-button
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button
                class="topBtn"
                type="text"
                @click="delPhoto(scope.row.id)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <div v-if="imgProp" class="propWrap">
        <div class="prop-content mobile_show">
          <i class="iconfont icon-close fr hand" @click="imgProp = false"></i>
          <p class="prop-title normal_font">查看圖片預覽</p>
          <img class="previewImg" :src="previewImgUrl" alt="" />
          <div class="bottomBtn">
            <!--<div class="btn">取消</div>-->
            <div class="btn hand new_btn" @click="imgProp = false">確認</div>
          </div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "新聞 ",
      navtitle: "私密相簿",
      listMenuForm: {
        startTime: ""
      },
      photoList: [],
      photoTable: [
        {
          prop: "block",
          label: "ID",
          width: "180"
        },
        {
          prop: "title",
          label: "相簿標題",
          width: "400"
        },
        {
          prop: "mainImg",
          label: "主圖",
          width: "200"
        },
        {
          prop: "block",
          label: "板塊",
          width: "100"
        },
        {
          prop: "startTime",
          label: "發佈時間",
          width: "180"
        },
        {
          prop: "status",
          label: "發佈狀態",
          width: "180"
        },
        {
          prop: "limits",
          label: "權限",
          width: "180"
        },
        {
          prop: "operate",
          label: "操作",
          width: "180"
        }
      ],
      currentPage: 1,
      total: 20,
      showNoneTips: false,
      // 预览图片
      previewImgUrl: "",
      imgProp: false,
      dialogVisible: false
    };
  },
  // created() {
  //   let _this = this
  //   _this.getPhotoList()
  // },
  activated() {
    let _this = this;
    _this.getPhotoList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    //隐藏
    getHide(id, status) {
      let param = { id: id, hide: status == "已隐藏" ? 0 : 1 };
      let _this = this;
      _this
        .$post(`/request/article/hide`, param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            if (status == "已隐藏") {
              _this.$propMessage("取消隐藏成功", "success", function() {
                _this.dialogVisible = false;
                _this.getPhotoList();
              });
            } else {
              _this.$propMessage("隐藏成功", "success", function() {
                _this.dialogVisible = false;
                _this.getPhotoList();
              });
            }
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 获取相簿列表
    getPhotoList() {
      let _this = this;
      let pushTime =
        _this.listMenuForm.startTime === "" ||
        _this.listMenuForm.startTime === null
          ? ""
          : _this.$formatDate(_this.listMenuForm.startTime);
      _this
        .$get(
          `/request/privateAlbum/${_this.currentPage}/10?pushTimeStart=${pushTime}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            if (res.data.list.length === 0) {
              _this.showNoneTips;
            } else {
              res.data.list.forEach(v => {
                v.pushTime = _this.$getTime(v.pushTime);
                if (v.status === 1) {
                  v.status = "已發佈";
                } else if (v.status === 2) {
                  v.status = "待發佈";
                } else if (v.status === 0) {
                  v.status = "未發/已刪除";
                } else if (v.status === 3) {
                  v.status = "已隐藏";
                }
              });
              _this.photoList = res.data.list;
              _this.total = res.data.allRow;
            }
            res.data.list.forEach(v => {
              v.pushTime = _this.$getTime(v.pushTime);
            });
            _this.photoList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 预览图片
    previewImg(url) {
      this.imgProp = true;
      this.previewImgUrl = url;
    },
    // 刪除相簿
    delPhoto(id) {
      console.log(id);
      let _this = this;
      this.$confirm(
        "是否刪除該相簿?刪除后該相簿下的所有照片將一并刪除且無法恢復",
        "提示信息",
        {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        }
      ).then(() => {
        // 确认删除的回调
        _this
          .$put(`/request/privateAlbum/${id}`, {}, _this.$GLOBAL.jsonConfig)
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("删除成功", "success", function() {
                _this.dialogVisible = false;
                _this.block = "";
                _this.getPhotoList();
              });
            } else {
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
              });
            }
          });
      });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getPhotoList();
    },
    // 搜索相簿
    search() {
      let _this = this;
      if (
        _this.listMenuForm.startTime === "" ||
        _this.listMenuForm.startTime === null
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇搜索條件", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.getPhotoList();
    },
    reset() {
      let _this = this;
      _this.listMenuForm.startTime = "";
      _this.currentPage = 1;
      _this.getPhotoList();
    },
    // 新聞置頂
    toTop(id, flag) {
      let _this = this;
      let param = {
        articleType: 10,
        articleId: id,
        top: Number(flag)
      };
      _this
        .$put(`/request/article/articleTop`, param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;

          if (res.code === "00000") {
            if (flag == 0) {
              _this.$propMessage("私密相簿取消置頂成功", "success", function() {
                _this.dialogVisible = false;
                _this.getPhotoList();
              });
            } else {
              _this.$propMessage("私密相簿置頂成功", "success", function() {
                _this.dialogVisible = false;
                _this.getPhotoList();
              });
            }
          } else if (res.code === "80001") {
            this.$confirm(
              "同時只支持一篇私密相簿置頂，請取消置頂後再設置?",
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            ).then(() => {});
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.content {
  .paddingContent {
    .ListMenu {
      .MenuBtnWrap {
        display: flex;
        justify-content: flex-end;

        .btn:last-child {
          margin-left: 0.2rem;
        }
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }

  .topBtn {
    width: 50px;
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}

.mainImgWrap {
  display: flex;
  justify-content: center;
  align-items: center;

  .mainImg {
    max-height: 0.6rem;
    max-width: 0.6rem;
    border-radius: 0.05rem;
  }

  p {
    min-width: 0.6rem;
    padding-left: 0.1rem;
    color: @mainColor;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/photoPrivacy/photoList.vue